import React from "react";
import { Carousel } from "antd";
const contentStyle = {
  margin: 0,
  height: "300px",
  textAlign: "center",
  border: "1px solid #E0E2E6",
  borderRadius: "16px",
  background: "#AEB3BA",
  boxShadow: "0px 4px 16px 0px #1018280F",
};
const preventContextMenu = (event) => {
  event.preventDefault();
};
export default function ImgCarousal({ data }) {
  console.log(data);
  const onChange = (currentSlide) => {
    // console.log(currentSlide);
  };
  const openImageInNewTab = (url) => {
  const newTab = window.open();
  newTab.document.write(`<img src="${url}" style="max-width:100%; height:auto;" />`);
};
  return (
    <>
    <Carousel arrows={true} dotPosition="right"   style={{cursor:'pointer'}}  afterChange={onChange}>
      {data.map((img) => {
        return (
          <div style={{textAlign:'center', cursor:'pointer'}} onClick={(e) => openImageInNewTab(img.objectUrl)}>
            <div style={{display:'flex',justifyContent:'center'}}>
            <img style={contentStyle} src={img.objectUrl} alt="example"
               onContextMenu={preventContextMenu}
            />
            </div>
          </div>
        );
      })}
    </Carousel>
    </>
  );
}
